import { apiFetch } from "@/lib/api";

export type SalesOrderZipCityFields = {
  zip: string;
  city: string;
  state: string;
  country: string;
};

export type SalesOrderZipCityCheckResult = {
  shipTo: string | null;
  billTo: string | null;
};

export function checkSalesOrderZipCities(input: {
  shipTo: SalesOrderZipCityFields;
  billTo: SalesOrderZipCityFields;
}): Promise<SalesOrderZipCityCheckResult> {
  return apiFetch<SalesOrderZipCityCheckResult>("/api/sales-orders/zip-city-check", {
    method: "POST",
    body: input,
  });
}
